import React from 'react';
import PropTypes from 'prop-types';

import '../styles/TimeZoneMenu.css';
import MenuHeader from './MenuHeader';

const TimeZoneMenu = ({ name }) => {
    const options = {
      year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric',
    };
    const currentDate = new Date();
    const currentDateToRender = new Intl.DateTimeFormat('en-US', options).format(currentDate);
    const currentZone = Intl.DateTimeFormat().resolvedOptions().timeZone; 
    const currentUTC = currentDate.toString().replace("GMT", "UTC").split(" ")[5];
    return (
      <>
        <MenuHeader itemName={name} />
        <div className="Time-zone-container">
            <div className="Time-zone-elements">
                <div className="Time-zone">{currentUTC}</div>
                <div>{currentZone}</div>
                <div>{currentDateToRender}</div>
            </div>
        </div>
      </>
    )
  }
  
TimeZoneMenu.propTypes = {
  name: PropTypes.string.isRequired,
};

export default TimeZoneMenu;
  